export const isBannerEnabled = (banner: any, isConsumerDeviceRegistered: boolean, isConsumerLoyaltyMember: boolean) => {
    if (!banner) return false;

    const {deviceRegistrationState, loyaltyMemberState} = banner;

    const deviceStateMatches =
        !deviceRegistrationState || deviceRegistrationState === String(isConsumerDeviceRegistered);

    const loyaltyStateMatches = !loyaltyMemberState || loyaltyMemberState === String(isConsumerLoyaltyMember);

    return deviceStateMatches && loyaltyStateMatches;
};
